import { FetchHelper, WITHOUT_BODY_METHODS, WITH_BODY_METHODS } from './FetchHelper.js';
export * from './FetchHelper.js';
const defaultConfig = {};
export function createInstance(defaultConfig) {
    const context = new FetchHelper(defaultConfig);
    const instance = context.request.bind(context);
    instance.default = defaultConfig || {};
    instance.create = (createConfig) => createInstance({
        ...defaultConfig,
        ...instance.default,
        ...createConfig,
    });
    WITHOUT_BODY_METHODS.map(val => val.toLowerCase()).forEach((value) => {
        instance[value] = (input, params, options) => instance(input, { ...defaultConfig, params, method: value, ...options });
    });
    WITH_BODY_METHODS.map(val => val.toLowerCase()).forEach((value) => {
        instance[value] = (input, body, options) => instance(input, { ...defaultConfig, body, method: value, ...options });
    });
    instance.request = options => instance(options.input, { ...defaultConfig, ...options });
    return instance;
}
const instance = createInstance(defaultConfig);
export default instance;
